module.exports = __webpack_public_path__ + "img/pr-4.5d75a691.png";